import { render, staticRenderFns } from "./ProjectSocialOverview.vue?vue&type=template&id=6171d3da&"
import script from "./ProjectSocialOverview.vue?vue&type=script&lang=js&"
export * from "./ProjectSocialOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports